import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { FIXED_ADDRESS, FIXED_COMPANY, generateCardPdf, safeCardFileName, type CardData } from "../business-card/generate-card";

// Internal-only page for the Logger Discord bot's "wizytowka" command.
// Playwright opens this with name/title/phone/email as query params, waits
// for [data-ready="1"], clicks [data-export="wizytowka"] and captures the
// download - it calls the exact same generateCardPdf() as the public
// /wizytowka page, so the bot posts a byte-identical PDF to what a person
// gets by filling in the form themselves.
export function DiscordBusinessCardExportPage() {
  const [params] = useSearchParams();
  const name = String(params.get("name") || "").trim();
  const title = String(params.get("title") || "").trim();
  const phone = String(params.get("phone") || "").trim();
  const email = String(params.get("email") || "").trim();

  const [error, setError] = useState("");
  const [pdf, setPdf] = useState<{ blob: Blob; filename: string } | null>(null);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setError("");
    setPdf(null);
    if (!name) {
      setError("Brak parametru name.");
      setBusy(false);
      return;
    }
    setBusy(true);
    const data: CardData = { name, title, company: FIXED_COMPANY, phone, address: FIXED_ADDRESS, email };
    generateCardPdf(data)
      .then((blob) => {
        if (cancelled) return;
        setPdf({ blob, filename: `business-card-${safeCardFileName(name)}.pdf` });
      })
      .catch((exc) => {
        if (!cancelled) setError(exc instanceof Error ? exc.message : String(exc));
      })
      .finally(() => {
        if (!cancelled) setBusy(false);
      });
    return () => { cancelled = true; };
  }, [name, title, phone, email]);

  function download() {
    if (!pdf) return;
    const url = URL.createObjectURL(pdf.blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = pdf.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  if (error) return <main data-error="1">{error}</main>;
  if (!pdf) return <main>Generuję wizytówkę…</main>;

  return (
    <main data-ready="1" data-busy={busy ? "1" : "0"} style={{ padding: 24, fontFamily: "Inter, Arial, sans-serif" }}>
      <button data-export="wizytowka" onClick={download}>Pobierz PDF</button>
    </main>
  );
}
